<template>
    <div style="margin-top: 1em">
        <div>
            <label><strong>* Nom :</strong></label>
            <input type="text" name="name"  class="form-control" placeholder="Nom" v-model="tariff.name" v-validate="'required'" data-vv-as="Nom">
            <div v-show="ferrors.has('name')" class="alert alert-danger">{{ ferrors.first('name') }}</div>

            <label><strong>* Thème (famille, stage, découverte...) :</strong></label>
            <input type="text" name="theme" class="form-control" v-model="tariff.theme" v-validate="'required'" data-vv-as="Theme">
            <div v-show="ferrors.has('theme')" class="alert alert-danger">{{ ferrors.first('theme') }}</div>

            <label ><strong>* Difficulté ( de 1 à 4 ) :</strong></label>
            <input type="number" class="form-control" name="difficulty" placeholder="Difficulté" v-model="tariff.difficulty" v-validate="'required'" data-vv-as="Difficulté">
            <div v-show="ferrors.has('difficulty')" class="alert alert-danger">{{ ferrors.first('difficulty') }}</div>

            <label ><strong>* Sommet :</strong></label>
            <input type="text" class="form-control" name="mountaintop" placeholder="Sommet" v-model="tariff.mountaintop" v-validate="'required'" data-vv-as="Sommet">
            <div v-show="ferrors.has('mountaintop')" class="alert alert-danger">{{ ferrors.first('mountaintop') }}</div>

            <label ><strong>* Durée :</strong></label>
            <input type="number" class="form-control" name="duration" placeholder="Durée (0.5, 1, 1.5...)" v-model="tariff.duration" v-validate="'required'" data-vv-as="Durée">
            <div v-show="ferrors.has('duration')" class="alert alert-danger">{{ ferrors.first('duration') }}</div>

            <label ><strong>* Personnes Max :</strong></label>
            <input type="number" class="form-control" name="max_persons" placeholder="nbr pers max" v-model="tariff.max_persons" v-validate="'required'" data-vv-as="Personnes Max">
            <div v-show="ferrors.has('max_persons')" class="alert alert-danger">{{ ferrors.first('max_persons') }}</div>

            <label ><strong>* Limite d'age :</strong></label>
            <input type="number" class="form-control" name="age_limit" placeholder="Limite d'age" v-model="tariff.age_limit" v-validate="'required'" data-vv-as="Limite d'âge">
            <div v-show="ferrors.has('age_limit')" class="alert alert-danger">{{ ferrors.first('age_limit') }}</div>

            <label  v-if="tariff.type === 'collectif'"><strong>* Prix par personne :</strong></label>
            <label v-if="tariff.type != 'collectif'"><strong>* Prix de l'activité :</strong></label>
            <input type="number" name="price" class="form-control" v-model="tariff.price"  v-validate="'required'" data-vv-as="Prix" >
            <div v-show="ferrors.has('price')" class="alert alert-danger">{{ ferrors.first('price') }}</div>

            <label ><strong>Commentaire :</strong></label>
            <input type="text" class="form-control" v-model="tariff.comment" number required>
        </div>
        <div v-if="paraglide">
            <label ><strong>* Décollage:</strong></label>
            <input type="text" class="form-control" v-model="tariff.takeoff" required>
            <label ><strong>* Rejoindre Décollage:</strong></label>
            <input type="text" class="form-contzrol" v-model="tariff.takeoff_appointment" required>
            <label ><strong>* Dénivelé:</strong></label>
            <input type="number" class="form-control" v-model="tariff.vertical_drop" number required>
            <label ><strong>* Lieu de décollage / Altitude:</strong></label>
            <input type="text" class="form-control" v-model="tariff.landing" required>
        </div>
        <button type="submit" class="btn btn-success" v-if="!edit" @click.prevent="sendTarif">Valider</button>
        <button type="submit" class="btn btn-primary" v-if="edit" @click.prevent="updateTarif">Modifier</button>
    </div>
</template>

<script>
export default {
  name: 'tariffForm',
  props:['tariff', 'edit', 'paraglide'],
  data () {
    return {
    }
  },
  methods: {
    sendTarif() {
        this.$validator.validateAll().then((result) =>{
            if (result) {
                this.$emit('storeTariff', this.tariff)
            }
            else
            {
                let msg = this.ferrors.all().length>1 ? 'Erreurs lors de la validation :' : 'Erreur lors de la validation :'
                this.customErrorMessage = {
                    error : true,
                    message : msg
                }
            }
        });
    },
    updateTarif () {
        this.$emit('updateTariff', this.tariff)
    }
  }
};
</script>

<style lang="css" scoped>
div > input{
    margin: 1em 0em;
}
button{
    margin-left: 1em;
    margin-top: 1.51em;
}
</style>
